//The API service is a self-contained static provider to talk to the certblock api
import ApiService from "./ApiService";

const certblockAPI = new ApiService();

/**
 * The OrderService is an abstraction layer for the Certblock API encapsulating API interactions revolving around
 * the management of order data. This includes available orders, delivery note numbers, order positions etc.
 */
export default class OrderService {

	/**
	 * Returns all orders, that are available to the current user. The set of
	 * suppliers is derived server-side from the caller's identity, so no
	 * supplier number is passed. Optionally filters for a specific prefix of the
	 * order number.
	 * @param orderNumberPrefix
	 * @return {Promise<void>}
	 */
	async getOrderList({orderNumberPrefix = ""} = {}) {
		return (await certblockAPI.callApi('orderList', [orderNumberPrefix])).data;
	}

	/**
	 * Returns Order Position data for a specific order
	 * @param orderNumber
	 * @return {Promise<void>}
	 */
	async getOrderPositions({orderNumber}) {
		if(!orderNumber) {
			console.error("ERROR[OrderService.getOrderPositions] No OrderNumber set as parameter to retrieve Order Position data");
			throw new Error("No OrderNumber set as parameter to retrieve Order Position data");
		}
	}


}